import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import orderBy from "lodash/orderBy";
import TextTooltip from "components/shared/TextTooltip";
import classNames from "components/ui/classNames";

interface IFamilyRelationshipsProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment;
}

export default function FamilyRelationships({ issuer }: IFamilyRelationshipsProps) {
  return (
    <div className="overflow-hidden rounded bg-white p-2">
      <table className="min-w-full border-collapse border-inherit text-left indent-0 text-sm tracking-wide">
        <thead className="bg-white">
          <tr>
            <th className="px-4 py-3 font-semibold uppercase text-neutral-700">Nome</th>
            <th className="px-4 py-3 font-semibold uppercase text-neutral-700">Pessoa Relacionada</th>
            <th className="px-4 py-3 font-semibold uppercase text-neutral-700">Parentesco</th>
          </tr>
        </thead>

        <tbody>
          {orderBy(issuer.familyRelationships, ["name"], ["asc"]).map((node, index) => {
            return (
              <tr
                key={`${node.name}/${String(index)}`}
                className={classNames(
                  "group border-t border-neutral-200",
                  "hover:border-t-transparent [&:hover+tr]:border-t-transparent",
                )}
              >
                <td
                  className={classNames(
                    "px-4 py-3 group-hover:bg-neutral-50",
                    "group-hover:first-of-type:rounded-l-md group-hover:last-of-type:rounded-r-md",
                  )}
                >
                  <div>
                    {node.position ? (
                      <TextTooltip
                        id={`FamilyRelationships/${node.name}/${index}/position`}
                        placement="top"
                        content={node.position}
                        style={{
                          padding: 12,
                          maxWidth: 320,
                          textAlign: "center",
                        }}
                      >
                        {({ accessibility, bind, ref }) => (
                          <span {...accessibility} {...bind} ref={ref} className="text-base font-medium text-slate-600">
                            {node.name}
                          </span>
                        )}
                      </TextTooltip>
                    ) : (
                      <span className="text-base font-medium text-slate-600">{node.name}</span>
                    )}
                  </div>

                  <div>
                    <span className="text-sm text-slate-500">{node.issuerSubsidiaryOrController}</span>
                  </div>
                </td>
                <td
                  className={classNames(
                    "px-4 py-3 group-hover:bg-neutral-50",
                    "group-hover:first-of-type:rounded-l-md group-hover:last-of-type:rounded-r-md",
                  )}
                >
                  <div>
                    <TextTooltip
                      id={`FamilyRelationships/${node.name}/${index}/position`}
                      placement="top"
                      content={node.relatedPersonPosition}
                      style={{
                        padding: 12,
                        maxWidth: 320,
                        textAlign: "center",
                      }}
                    >
                      {({ accessibility, bind, ref }) => (
                        <span {...accessibility} {...bind} ref={ref} className="text-base font-medium text-slate-600">
                          {node.relatedPersonName}
                        </span>
                      )}
                    </TextTooltip>
                  </div>

                  <div>
                    <span className="text-sm text-slate-500">{node.relatedPersonIssuerSubsidiaryOrController}</span>
                  </div>
                </td>
                <td
                  className={classNames(
                    "px-4 py-3 group-hover:bg-neutral-50",
                    "group-hover:first-of-type:rounded-l-md group-hover:last-of-type:rounded-r-md",
                  )}
                >
                  <span className="text-base text-slate-600">{node.relationship}</span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
